import React from 'react';
import { Outlet } from 'react-router-dom';
import { PublicNav } from './PublicNav';
import { PublicFooter } from './PublicFooter';
import { ScrollToTop } from './ScrollToTop';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF8]" data-testid="public-layout">
      <ScrollToTop />
      <PublicNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
